<template>
  <div>
    <section class="content-header">
      <h1>
        อินเทอร์เน็ตความเร็วสูงประจำที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-fw fa-file-o"></i> อินเทอร์เน็ตความเร็วสูงประจำที่
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <div class="col-sm-12">
                      <el-form
                        size="mini"
                        :label-position="label_position"
                        label-width="100px"
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        class="demo-ruleForm"
                      >
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย" prop="namePromotion">
                            <el-input v-model="ruleForm.namePromotion"></el-input>
                          </el-form-item>
                          <el-form-item label="ผู้ให้บริการ" prop="region">
                            <el-input v-model="ruleForm.region"></el-input>
                          </el-form-item>
                          <el-form-item label="ประเภทบริการ" prop="type">
                            <el-input v-model="ruleForm.type"></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ชนิดของประเภทบริการ" prop="ss">
                            <el-select v-model="ruleForm.ss" placeholder="please select your zone">
                              <el-option label="Zone one" value="shanghai"></el-option>
                              <el-option label="Zone two" value="beijing"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลาในการค้นหา">
                            <el-date-picker
                              v-model="value1"
                              type="datetimerange"
                              range-separator="To"
                              start-placeholder="Start date"
                              end-placeholder="End date"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ช่วงราคา">
                            <el-slider v-model="value2" :step="0.0001" range :max="1"></el-slider>
                          </el-form-item>
                        </div>
                        <div class="layout_filter_btn">
                          <el-button type="primary" @click="submitForm('ruleForm')">Submit</el-button>
                        </div>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.box-header -->
              <div class="wrapper_chart">
                <div class="layout_btn_export">
                  <a href class="btn btn-primary">Export</a>
                </div>
              </div>
              <div class="table-responsive">
                <div class="box-body">
                  <div class="box-body">
                    <data-tables
                      :data="data"
                      :table-props="tableProps"
                      :page-size="5"
                      :pagination-props="{ background: true, pageSizes: [5, 10, 15] }"
                      :action-col="actionCol"
                    >
                      <el-table-column
                        v-for="title in titles"
                        :prop="title.prop"
                        :label="title.label"
                        :key="title.label"
                        sortable="custom"
                      ></el-table-column>
                      <!-- <p slot="append">table slot</p> -->
                    </data-tables>
                  </div>
                </div>
                <!-- /.box-body -->
              </div>
              <!--table-responsive-->
            </div>
            <!-- /.box -->
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      actionCol: {
        label: "Actions",
        props: {
          align: "center"
        },
        buttons: [
          {
            props: {
              type: "primary",
              icon: "el-icon-edit"
            },
            handler: row => {
              this.$message("Edit clicked");
              row.flow_no = "hello word" + Math.random();
              row.content = Math.random() > 0.5 ? "Water flood" : "Lock broken";
              row.flow_type = Math.random() > 0.5 ? "Repair" : "Help";
            },
            label: "Edit"
          },
          {
            handler: row => {
              this.data.splice(this.data.indexOf(row), 1);
            },
            label: "delete"
          },
          {
           props:{
             type: "danger"
           } ,
            handler: row => {
              console.log(row.flow_no)
            },
            label: "view"
          }
        ]
      },
      tableProps: {
        border: true,
        defaultSort: {
          prop: "flow_no",
          order: "descending"
        }
      },
      rules: {
        namePromotion: [
          {
            required: true,
            message: "กรุณากรอกชื่อโปรโมชั่น",
            trigger: "blur"
          },
          { min: 2, max: 10, message: "ความยาว 1 ถึง 10", trigger: "blur" }
        ],
        region: [
          { required: true, message: "กรุณาเลือกผู้ให้บริการ", trigger: "blur" }
        ],
        type: [
          { required: true, message: "กรุณาเลือกประเภทบริการ", trigger: "blur" }
        ],
        ss: [
          {
            required: true,
            message: "กรุณาเลือกประเภทบริการ",
            trigger: "change"
          }
        ]
      },
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      value2: ["0.32", "0.945"],
      ruleForm: {
        ss: "shanghai",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      sizeForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      label_position: "top",
      data: [
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        },
        {
          content: "Water flood",
          flow_no: "FW201601010001",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Lock broken",
          flow_no: "FW201601010002",
          flow_type: "Repair",
          flow_type_code: "repair"
        },
        {
          content: "Help to buy some drinks",
          flow_no: "FW201601010003",
          flow_type: "Help",
          flow_type_code: "help"
        }
      ],
      titles: [
        {
          prop: "flow_no",
          label: "NO."
        },
        {
          prop: "content",
          label: "Content"
        },
        {
          prop: "flow_type",
          label: "Type"
        }
      ],
      loading: false,
      total: 0
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit");
          return false;
        }
      });
    }
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // }
  }
};
</script>

<style>
.el-button.el-button--primary {
  background-color: #3c8dbc;
  border-color: #367fa9;
}
</style>
